import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div style={{
        backgroundColor: '#fff',
        padding: '12px',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}>
        <p style={{ fontWeight: '600', marginBottom: '8px', color: data.color }}>{data.name}</p>
        <p style={{ color: '#374151', margin: '4px 0' }}>
          Adet: <strong>{data.count}</strong>
        </p>
        <p style={{ color: '#374151', margin: '4px 0' }}>
          Tutar: <strong>${data.total_amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
        </p>
        {data.total_balance > 0 && (
          <p style={{ color: '#dc2626', margin: '4px 0' }}>
            Bakiye: <strong>${data.total_balance.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
          </p>
        )}
      </div>
    );
  }
  return null;
};

const InvoiceStatsChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div style={{ 
        height: '250px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: '#6b7280'
      }}>
        Yükleniyor...
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div style={{ 
        height: '250px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: '#6b7280'
      }}>
        Veri bulunamadı
      </div>
    );
  }

  // Sort by count descending
  const sortedData = [...data].sort((a, b) => b.count - a.count);

  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart 
          data={sortedData} 
          layout="vertical"
          margin={{ top: 5, right: 30, left: 80, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" horizontal={true} vertical={false} />
          <XAxis 
            type="number"
            tick={{ fill: '#6b7280', fontSize: 12 }}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <YAxis 
            type="category"
            dataKey="name"
            tick={{ fill: '#6b7280', fontSize: 12 }}
            axisLine={{ stroke: '#e5e7eb' }}
            width={75}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar 
            dataKey="count" 
            radius={[0, 4, 4, 0]}
          >
            {sortedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      
      {/* Summary Cards */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(3, 1fr)', 
        gap: '12px',
        marginTop: '16px'
      }}>
        {sortedData.slice(0, 3).map((item, index) => (
          <div 
            key={index}
            style={{
              padding: '12px',
              backgroundColor: '#f8fafc',
              borderRadius: '8px',
              borderLeft: `4px solid ${item.color}`
            }}
          >
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
              {item.name}
            </div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#1f2937' }}>
              {item.count}
            </div>
            <div style={{ fontSize: '12px', color: '#059669' }}>
              ${item.total_amount.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceStatsChart;
